/**
 * 화면 정합성 헬퍼 — 운영 데이터 mutation 의 onSuccess 에서 호출.
 *
 * 영업/매입/유지보수/재고/품목/매출분석/대시보드 등 화면들의 queryKey 가 다양하고
 * 의존 관계 (영업 등록 → 매출분석 합산, 매입 등록 → 재고 표시) 를 모두 분류해서
 * 매번 명시 invalidate 하면 누락 위험 큼.
 *
 * internal 앱이라 부담이 작으므로 단순히 모든 쿼리 invalidate — 누락 zero.
 *
 *   const mut = useMutation({
 *     ...
 *     onSuccess: () => { syncAllData(qc); onSaved(); },
 *   });
 *
 * 안전망 3중 구조의 1단계:
 *   1) syncAllData (mutation 직후 즉시)  ← 본 헬퍼
 *   2) LastUpdateBadge ↻ (사용자 수동)
 *   3) AutoSyncTicker (1시간 자동)
 */

import type { QueryClient } from '@tanstack/react-query';

export function syncAllData(qc: QueryClient): void {
  void qc.invalidateQueries();
}
